import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Search, Twitter, Linkedin, Mail } from "lucide-react";

const Footer = () => {
  const location = useLocation();

  const handleLinkClick = (path) => {
    // If clicking on the same page, scroll to top
    if (location.pathname === path) {
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer className="bg-slate-900 text-slate-300 border-t border-slate-800">
      <div className=" max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-8">
        <div className="grid grid-cols-1 text-center md:text-left md:grid-cols-4 gap-12 mb-12">
          {/* Column 1: Brand & Bio */}
          <div className="col-span-1 md:col-span-1">
            <Link
              to="/"
              onClick={() => handleLinkClick("/")}
              className=" flex justify-center md:justify-start items-center gap-2 mb-6 group"
            >
              <div className="bg-blue-600 p-1.5 rounded-lg text-white group-hover:bg-blue-500 transition">
                <Search className="h-5 w-5" />
              </div>
              <span className="font-bold text-xl text-white tracking-tight">
                Searchy<span className="text-blue-500">.io</span>
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-6">
              Searchy.io, a product of ThreeDotsOnline LTD. We verify, filter, and deliver
              high-quality traffic to premium advertisers worldwide.
            </p>

            {/* Social Icons */}
            <div className="flex gap-4 justify-center md:justify-start">
              <a
                href="https://twitter.com/messages/compose"
                target="_blank"
                rel="noopener noreferrer"
                className="h-8 w-8 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all cursor-pointer"
                aria-label="Send us a message on Twitter"
              >
                <Twitter className="h-4 w-4" />
              </a>
              <a
                href="https://www.linkedin.com/messaging/compose/"
                target="_blank"
                rel="noopener noreferrer"
                className="h-8 w-8 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all cursor-pointer"
                aria-label="Send us a message on LinkedIn"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="mailto:support@searchy.io"
                className="h-8 w-8 rounded-full bg-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white transition-all cursor-pointer"
                aria-label="Send us an email"
              >
                <Mail className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Columns 2-4: Links (Reduced to 3 per column) */}
          {[
            {
              title: "Technology",
              links: [
                // הכל מפנה ל-About כי שם מוסבר על הטכנולוגיה
                { name: "Intent Engine", path: "/about" },
                { name: "Brand Safety", path: "/about" },
                { name: "Ad Delivery", path: "/about" },
              ],
            },
            {
              title: "Company",
              links: [
                // הכל מפנה ל-Contact או About
                { name: "About Us", path: "/about" },
                { name: "Careers", path: "/contact" }, // מפנה ליצירת קשר (כאילו "שלחו קו"ח")
                { name: "Contact", path: "/contact" },
              ],
            },
            {
              title: "Legal",
              links: [
                // הכל מפנה ל-Privacy כי זה הדף המשפטי היחיד שיש לנו
                { name: "Privacy Policy", path: "/privacy" },
                { name: "Terms of Service", path: "/privacy" },
                { name: "Security Standards", path: "/about" },
              ],
            },
          ].map((col, idx) => (
            <div key={idx}>
              <h4 className="font-bold text-white mb-6 uppercase text-xs tracking-wider border-b border-slate-800 pb-2 inline-block">
                {col.title}
              </h4>
              <ul className="space-y-3 text-sm">
                {col.links.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.path}
                      onClick={() => handleLinkClick(link.path)}
                      className="text-slate-400 hover:text-blue-400 transition-colors block hover:translate-x-1 duration-200"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-xs font-medium text-slate-500">
          <p>© {new Date().getFullYear()} ThreeDotsOnline LTD. All rights reserved.</p>
          <div className="flex gap-6">
            <span className="hover:text-slate-300 cursor-pointer transition">Security</span>
            <span className="hover:text-slate-300 cursor-pointer transition">Sitemap</span>
            <span className="flex items-center gap-1">
              <span className="h-2 w-2 rounded-full bg-green-500"></span>
              Systems Operational
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
